import api from './api'
import type {
  CentralPendencias,
  CentralPendenciasResumo,
  Pendencia,
  PendenciaCriarRequest,
  PendenciaInteracao,
  PendenciaStatus,
} from '@/types/pendencia'

const BASE = '/api/v1/pendencias'

// O interceptor de `api` já devolve o body HTTP (o backend de oportunidades não
// embrulha em ApiResponse) — daí os casts `as unknown as T`, como nos demais serviços.
export const pendenciaService = {
  listarPorReserva: async (reservaId: string): Promise<Pendencia[]> => {
    const r = await api.get<Pendencia[]>(BASE, { params: { reservaId } })
    return r as unknown as Pendencia[]
  },

  minhas: async (): Promise<Pendencia[]> => {
    const r = await api.get<Pendencia[]>(`${BASE}/minhas`)
    return r as unknown as Pendencia[]
  },

  criar: async (req: PendenciaCriarRequest): Promise<Pendencia> => {
    const r = await api.post<Pendencia>(BASE, req)
    return r as unknown as Pendencia
  },

  /**
   * Resposta do consultor. `confirmaAtualizado` (Fase 6, item 21) é a atestação de que o
   * enviado está atualizado — vai para a resposta e para o histórico da pendência.
   */
  responder: async (id: string, resposta: string, confirmaAtualizado = false): Promise<Pendencia> => {
    const r = await api.post<Pendencia>(`${BASE}/${id}/responder`, { resposta, confirmaAtualizado })
    return r as unknown as Pendencia
  },

  transicionar: async (
    id: string,
    novoStatus: PendenciaStatus,
    observacao?: string,
  ): Promise<Pendencia> => {
    const r = await api.patch<Pendencia>(`${BASE}/${id}/status`, { novoStatus, observacao })
    return r as unknown as Pendencia
  },

  historico: async (id: string): Promise<PendenciaInteracao[]> => {
    const r = await api.get<PendenciaInteracao[]>(`${BASE}/${id}/interacoes`)
    return r as unknown as PendenciaInteracao[]
  },

  /**
   * Central de Pendências do consultor (VC-09 parte 2): tudo o que ele precisa fazer —
   * pendências, documentos obrigatórios faltando, NF a emitir, próximas ações e reuniões.
   * Só consultor (back-office recebe 403). Escopo = o `sub` do token. Vem com o resumo
   * (KPIs) do mesmo cálculo — a tela não precisa chamar `centralResumo()`.
   */
  central: async (): Promise<CentralPendencias> => {
    const r = await api.get<CentralPendencias>(`${BASE}/central`)
    return r as unknown as CentralPendencias
  },

  /**
   * Só os KPIs da Central (mesma contagem de `central().resumo`) — para quem não exibe a
   * lista, como o card do dashboard do consultor.
   */
  centralResumo: async (): Promise<CentralPendenciasResumo> => {
    const r = await api.get<CentralPendenciasResumo>(`${BASE}/central/resumo`)
    return r as unknown as CentralPendenciasResumo
  },
}
